import axios from "axios";
import store from '../store';
import AppConsts from "../../appconst";
import * as actions from "./UserMasterTypes";
import { UserLogout } from '../Login/LoginActions';
import { Modal } from 'antd';

var logout = false;

export const getRoleList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/User/GetRoleList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETUSERROLE, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout() }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const getManagerList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/User/GetManagerList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETMANAGER, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout() }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const getPolicyList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/User/GetPolicyList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETUSERPOLICY, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout() }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const getDepartmentList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/User/GetDepartmentList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETDEPARTLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout() }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const getVendorCodeList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/User/GetVendorCodeList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETVENDORCODE, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout() }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const getUserList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/User/GetUserList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETUSERLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout() }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const getUserData = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/User/GetUserData",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETUSERDATA, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout() }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};

export const saveUser = async (data) => {
    try {
        var result =
            await axios({
                method: 'post',
                url: AppConsts.apiBaseUrl + "/User/SaveUser",
                data: data,
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("token"),
                    "Content-Type": "application/json"
                },
            })
                .then(response => {
                    return response.data;
                })
                .catch(err => {
                    if (err.response.status == 401) {
                        if (!logout) {
                            logout = true;
                            Modal.confirm({
                                content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                                onOk: () => { UserLogout() }
                            });
                        }
                    }
                    return { result: false, message: err.message };
                });

        return result;
    }
    catch (err) {
        return { result: false, message: err.message };
    }
};

export const saveMultipleUsers = async (data) => {
    try {
        var result =
            await axios({
                method: 'post',
                url: AppConsts.apiBaseUrl + "/User/SaveMultipleUsers",
                data: data,
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("token"),
                    "Content-Type": "application/json"
                },
            })
                .then(response => {
                    return response.data;
                })
                .catch(err => {
                    if (err.response.status == 401) {
                        if (!logout) {
                            logout = true;
                            Modal.confirm({
                                content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                                onOk: () => { UserLogout() }
                            });
                        }
                    }
                    return { result: false, message: err.message };
                });

        return result;
    }
    catch (err) {
        return { result: false, message: err.message };
    }
};

export const updateMultipleUsers = async (data) => {
    try {
        var result =
            await axios({
                method: 'post',
                url: AppConsts.apiBaseUrl + "/User/UpdateMultipleUsers",
                data: data,
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("token"),
                    "Content-Type": "application/json"
                },
            })
                .then(response => {
                    return response.data;
                })
                .catch(err => {
                    if (err.response.status == 401) {
                        if (!logout) {
                            logout = true;
                            Modal.confirm({
                                content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                                onOk: () => { UserLogout() }
                            });
                        }
                    }
                    return { result: false, message: err.message };
                });

        return result;
    }
    catch (err) {
        return { result: false, message: err.message };
    }
};

export const updateUserStatus = async (data) => {
    try {
        var result =
            await axios({
                method: 'post',
                url: AppConsts.apiBaseUrl + "/User/UpdateUserStatus",
                data: data,
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("token"),
                    "Content-Type": "application/json"
                },
            })
                .then(response => {
                    return response.data;
                })
                .catch(err => {
                    if (err.response.status == 401) {
                        if (!logout) {
                            logout = true;
                            Modal.confirm({
                                content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                                onOk: () => { UserLogout() }
                            });
                        }
                    }
                    return { result: false, message: err.message };
                });

        return result;
    }
    catch (err) {
        return { result: false, message: err.message };
    }
};

export const forgotPassword = async (data) => {
    try {
        var result =
            await axios({
                method: 'post',
                url: AppConsts.apiBaseUrl + "/Login/ForgotPassword",
                data: data,
                headers: {
                    "Content-Type": "application/json"
                },
            })
                .then(response => {
                    return response.data;
                })
                .catch(err => {
                    if (err.response.status == 401) {
                        if (!logout) {
                            logout = true;
                            Modal.confirm({
                                content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                                onOk: () => { UserLogout() }
                            });
                        }
                    }
                    return { result: false, message: err.message };
                });

        return result;
    }
    catch (err) {
        return { result: false, message: err.message };
    }
};

export const checkResetPasswordLink = async (data) => {
    try {
        var result = await axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Login/CheckResetPasswordLink",
            params: data,
            headers: {
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout() }
                        });
                    }
                }
                console.log({ content: err.message });
                return { result: false, message: err };
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return { result: false, message: err }
    }
};

export const resetPassword = async (data) => {
    try {
        var result =
            await axios({
                method: 'post',
                url: AppConsts.apiBaseUrl + "/Login/resetPassword",
                data: data,
                headers: {
                    "Content-Type": "application/json"
                },
            })
                .then(response => {
                    return response.data;
                })
                .catch(err => {
                    if (err.response.status == 401) {
                        if (!logout) {
                            logout = true;
                            Modal.confirm({
                                content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                                onOk: () => { UserLogout() }
                            });
                        }
                    }
                    return { result: false, message: err.message };
                });

        return result;
    }
    catch (err) {
        return { result: false, message: err.message };
    }
};

export const getDesignationList = async (data) => {
    try {
        axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/User/GetDesignationList",
            params: data,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                store.dispatch({ type: actions.SETDESIGNATIONLIST, payload: { list: response.data } });
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout() }
                        });
                    }
                }
                console.log({ content: err.message });
            });
    }
    catch (err) {
        console.log({ content: err.message });

    }
};
